import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=ace371b0&scoped=true&"
var script = {}
import style0 from "./Page404.vue?vue&type=style&index=0&id=ace371b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace371b0",
  null
  
)

export default component.exports